import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import * as Sentry from '@sentry/angular';
import { sentrySafeHttpPath, shouldEmitSentryBreadcrumb } from '../utils/sentry-telemetry.util';

/**
 * End-to-end HTTP timing breadcrumbs (path + status + duration only).
 * Outermost in chain so cache hits are included. / قياس زمن HTTP مع مسار وحالة فقط
 */
@Injectable()
export class SentryHttpMonitoringInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const started = performance.now();
    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          this.emit(req, event.status, performance.now() - started, 'completed');
        }
      }),
      catchError((err: unknown) => {
        const status = err instanceof HttpErrorResponse ? err.status : 0;
        this.emit(req, status, performance.now() - started, 'error');
        return throwError(() => err);
      })
    );
  }

  private emit(
    req: HttpRequest<unknown>,
    status: number,
    durationMs: number,
    outcome: 'completed' | 'error'
  ): void {
    if (!shouldEmitSentryBreadcrumb()) {
      return;
    }
    const path = sentrySafeHttpPath(req.url);
    Sentry.addBreadcrumb({
      category: 'http',
      type: 'http',
      level: outcome === 'error' ? 'error' : 'info',
      message: `${req.method} ${path}`,
      data: {
        method: req.method,
        path,
        status_code: status,
        duration_ms: Math.round(durationMs),
        outcome,
      },
    });
  }
}
